import { useEffect, useMemo, useState } from "react";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { BtnGroupWAStyle, ContentStyle, RxTabsStyle } from "../../Theme";
import DeleteIcon from "../../images/icons/DeleteIcon.svg";
import TabsNav from "../../components/TabsNav";
import PrescriptionSummary from "./PrescriptionSummary";
import RxForm from "./RxForm";
import { DialogPopup } from "../../components/DialogPopup";
import { YSButton } from "../../uikit/YSButton";
import { useLocation, useNavigate } from "react-router";
import {
  ADDNEWPRESC,
  ConfirmSavedPrescriptions,
  DrugPopulate,
  EditSavedPrescrition,
  InitializeRxPad,
  PostDatedEdit,
  SubmitPresctiptions,
} from "../../Apis/AuthApiServices";
import YSSnackBar from "../../uikit/YSSnackBar";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { isDocereeAdsEnabled } from "../../utils/envConfig";
import { getDiagnosis, getPatientId } from "../../utils/patientSession";
import { loadingSavedPrescriptions } from "../../Redux/Slice/SavedPrescriptionSlice";
import { loadingPharmacyDropDown } from "../../Redux/Slice/PharmacyDropDownSlice";
import { loadingAllSavedPrescriptions } from "../../Redux/Slice/AllSavedPrescriptionsSlice";
import {
  disableClinic,
  enableClinic,
} from "../../Redux/Slice/ClinicDisableSlice";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

export default function NewRxPadSingle() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state }: any = useLocation();
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const patientState = useSelector((state: any) => {
    return { ...state?.PatientDetailsSlice?.AllPatientDetails };
  }); //redux data
  const AllDropdwonsState = useSelector((state: any) => {
    return { ...state?.GlobalDropdownSlice?.DropdownLists };
  }); //redux data
  const [selectedTab, setSelectedTab] = useState("Rx 1");
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [summaryTab, setSummaryTab] = useState(false);
  const [deleteDataPopup, setDeleteDataPopup] = useState(false);
  const [deteteRxData, setdeleteRxdata] = useState("");
  const [tabValue, setTabValue] = useState(1);
  const [pdmpPopup, setPdmpPopup] = useState(false);
  const rxTabsData: any =
    sessionStorage.getItem("rxTabs") !== "undefined" ||
    sessionStorage.getItem("rxTabs") !== null
      ? JSON.parse(sessionStorage.getItem("rxTabs")!)
      : null;
  const [tabList, setTabList] = useState<any>([]);
  const memoData = useMemo(() => {
    return tabList?.map((item: any) => item);
  }, [tabList]);

  const handleShowDeletePopupClick = () => {
    setDeleteDataPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeleteDataPopup(false);
  };
  const handleHidePdmpPopupClick = () => {
    sessionStorage.setItem("pdmpPopup", "false");
    setPdmpPopup(false);
  };
  const getLabels = (values: any) => {
    let timelabels = "";
    if (values.sigTimeMorning === "ON") timelabels = timelabels + " at morning";
    if (values.sigTimeNight === "ON") timelabels = timelabels + " at night";
    if (values.sigTimeAfterMeals === "ON")
      timelabels = timelabels + " at after meals";
    if (values.sigTimeBedTime === "ON") timelabels = timelabels + " at bedtime";
    if (values.sigTimeNoon === "ON") timelabels = timelabels + " at noon";
    if (values.sigTimeBeforeBed === "ON")
      timelabels = timelabels + " at before bed";
    if (values.sigTimeBeforeMeals === "ON")
      timelabels = timelabels + " at before meals";
    if (values.sigTimeEvening === "ON") timelabels = timelabels + " at evening";
    let currentDelivery = AllDropdwonsState?.sigDeliveryOptions?.find(
      (each: any) => each?.sfid == values.sigDeliveryId
    );
    let currentDose = AllDropdwonsState?.sigDoseOptions?.find(
      (each: any) => each?.sfid == values.sigDoseId
    );
    let currentUnits = AllDropdwonsState?.sigDoseUnitsOptions?.find(
      (each: any) => each?.sfid == values.sigDoseUnitsId
    );
    let currentFreq = AllDropdwonsState?.sigFreqOptions?.find(
      (each: any) => each?.sfid == values.sigFreqId
    );

    return `${currentDelivery?.name ?? ""} ${currentDose?.name ?? ""} ${
      currentUnits?.name ?? ""
    } ${currentFreq?.name ?? ""} ${timelabels}`;
  };

  const newPrescription = async (values: any, validation: any) => {
    try {
      //setTabList([...tabList, values]);
      if (
        values.sig === "" ||
        values.sigFrqId ||
        values.sigDeliveryId ||
        values.sigDoseId ||
        values.sigDoseUnitsId
      ) {
        values.sig = getLabels(values);
      }
      values.sig = values.sig.trim();
      setLoading(true);
      const bodyData = {
        prescriptionForm: values ?? [],
        patientId: patientId,
        userDetails: {
          doctorId: doctorId,
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result: any = await ADDNEWPRESC(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setLoading(false);
        if (result?.data?.response[0]?.prescriptionErrors?.length >= 1) {
          sessionStorage.setItem(
            "rxTabsErrors",
            JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
          );
          tabList.pop();
          sessionStorage.setItem(
            "rxTabs",
            JSON.stringify([...tabList, values])
          );
          setTabList([...tabList, values]);
          setStateData((prevState: any) => {
            return {
              ...prevState,
              message: result?.data?.response[0]?.prescriptionErrors?.map(
                (each: any) => {
                  return (
                    <Box>
                      <Typography
                        component={"div"}
                        fontWeight={600}
                        variant={"body2"}
                      >
                        <strong> Rx-{each?.rxNumber}</strong>
                      </Typography>
                      {each?.errors?.map((ech: any) => {
                        return (
                          <Typography
                            component={"div"}
                            fontWeight={600}
                            variant={"body2"}
                            paddingLeft={2}
                          >
                            {" - "} {ech?.errorMessage}
                          </Typography>
                        );
                      })}
                    </Box>
                  );
                }
              ),
              variant: "error",
              open: true,
            };
          });
        } else {
          const errorPads =
            sessionStorage.getItem("rxTabsErrors") != undefined ||
            sessionStorage.getItem("rxTabsErrors") != null
              ? JSON.parse(sessionStorage.getItem("rxTabsErrors")!)
              : null;
          const removeErrorPad = errorPads?.filter(
            (t: any) => t?.rxNumber !== values.rxNumber
          );
          if (removeErrorPad == undefined || removeErrorPad == null) {
            sessionStorage.setItem("rxTabsErrors", JSON.stringify([]));
          } else {
            sessionStorage.setItem(
              "rxTabsErrors",
              JSON.stringify(removeErrorPad)
            );
          }

          addNewTab(result?.data?.response[0]?.prescriptionForm, values);
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    } catch (eror) {
      setLoading(false);
    }
  };
  const saveAndContinue = async (values: any, validation: any) => {
    try {
      setLoading(true);
      let prescriptionForm = values || {};
      const currentTab = parseInt(
        JSON.parse(sessionStorage.getItem("TabValue")!)
      );
      const forms: [] =
        sessionStorage.getItem("rxTabs") !== "undefined" ||
        sessionStorage.getItem("rxTabs") !== null
          ? JSON.parse(sessionStorage.getItem("rxTabs")!)
          : [];
      if (
        values.sig === "" ||
        values.sigFrqId ||
        values.sigDeliveryId ||
        values.sigDoseId ||
        values.sigDoseUnitsId
      ) {
        values.sig = getLabels(values);
      }
      values.sig = values.sig.trim();
      const bodyData = {
        prescriptionForm: values ?? [],
        patientId: patientId,
        userDetails: {
          doctorId: doctorId,
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const updatedForm = forms.map((form: any) => {
        if (form.rxNumber == currentTab) {
          return (form = values);
        } else {
          return form;
        }
      });
      sessionStorage.setItem("rxTabs", JSON.stringify(updatedForm));
      setTabList(updatedForm);
      const result: any = await ADDNEWPRESC(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        if (result?.data?.response[0]?.prescriptionErrors?.length >= 1) {
          sessionStorage.setItem(
            "rxTabsErrors",
            JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
          );
          setStateData((prevState: any) => {
            return {
              ...prevState,
              message: result?.data?.response[0]?.prescriptionErrors?.map(
                (each: any) => {
                  return (
                    <Box>
                      <Typography
                        component={"div"}
                        fontWeight={600}
                        variant={"body2"}
                      >
                        <strong> Rx-{each?.rxNumber}</strong>
                      </Typography>
                      {each?.errors?.map((ech: any) => {
                        return (
                          <Typography
                            component={"div"}
                            fontWeight={600}
                            variant={"body2"}
                            paddingLeft={2}
                          >
                            {" - "} {ech?.errorMessage}
                          </Typography>
                        );
                      })}
                    </Box>
                  );
                }
              ),
              variant: "error",
              open: true,
            };
          });
          setSelectedTab(
            `Rx ${result?.data?.response[0]?.prescriptionErrors[0].rxNumber}`
          );
          setLoading(false);
        } else {
          const errorPads =
            sessionStorage.getItem("rxTabsErrors") != "undefined" ||
            sessionStorage.getItem("rxTabsErrors") !== null
              ? JSON.parse(sessionStorage.getItem("rxTabsErrors")!)
              : null;
          if (errorPads != null) {
            const removeErrorPad = errorPads?.filter(
              (t: any) => t?.rxNumber !== values.rxNumber
            );
            sessionStorage.setItem(
              "rxTabsErrors",
              JSON.stringify(removeErrorPad)
            );
          }

          setSelectedTab(`Rx ${currentTab + 1}`);
          sessionStorage.setItem(
            "TabValue",
            JSON.stringify((currentTab + 1)?.toString())
          );
          setTabValue(currentTab + 1);
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };
  const addNewTab = (resultData: any, preValues: any) => {
    const value = `Rx ${tabList.length + 1}`;
    let prescriptionForm = resultData || {};

    prescriptionForm.rxNumber = tabList.length + 1;
    tabList.pop();
    sessionStorage.setItem(
      "rxTabs",
      JSON.stringify([...tabList, preValues, prescriptionForm])
    );
    setTabList([...tabList, preValues, prescriptionForm]);
    //sessionStorage.setItem("rxTabs", JSON.stringify(tabList));
    setSelectedTab(value);
    sessionStorage.setItem("TabValue", JSON.stringify(value.split(" ")[1]));
    //setTabIndex(tabIndex + 1);
    setTabValue(tabValue + 1);

    // setTabValue((prevValue: any) => prevValue + 1);
  };
  const handleClose = (event: any, value: any) => {
    event.stopPropagation();
    const tabArr = tabList
      ?.filter((t: any) => t?.rxNumber !== value)
      .map((each: any, index: any) => {
        each.rxNumber = index + 1;
        return each;
      });
    //setTabList(tabArr);
    setSelectedTab(`Rx ${value - 1}`);
    sessionStorage.setItem("TabValue", JSON.stringify(value - 1));

    setTabValue((prevValue: any) => prevValue - 1);
    sessionStorage.setItem("rxTabs", JSON.stringify(tabArr));
    setTabList(tabArr);
    if (tabArr?.length === 1 && !tabArr[0]?.drugId) {
      dispatch(enableClinic());
    } else {
      dispatch(disableClinic());
    }
  };

  const handleChange = (event: any, newValue: any) => {
    if (newValue === "summary") {
      navigate("/newrxpad/summary");
    } else {
      navigate("/newrxpad");
    }
    setSelectedTab(newValue);
    sessionStorage.setItem("TabValue", JSON.stringify(newValue.split(" ")[1]));
    //setTabIndex(newValue === "Rx 1" ? 1 : newValue.split(" ")[1]);
  };

  const [submitLoad, setSubmitLoad] = useState(false);
  const submitAllForms = async (values: any) => {
    try {
      const forms: [] =
        sessionStorage.getItem("rxTabs") !== "undefined" ||
        sessionStorage.getItem("rxTabs") !== null
          ? JSON.parse(sessionStorage.getItem("rxTabs")!)
          : [];
      setSubmitLoad(true);
      if (
        values.sig === "" ||
        values.sigFrqId ||
        values.sigDeliveryId ||
        values.sigDoseId ||
        values.sigDoseUnitsId
      ) {
        values.sig = getLabels(values);
      }
      values.sig = values.sig.trim();
      // tabList.pop();
      // sessionStorage.setItem("rxTabs", JSON.stringify([...tabList, values]));
      const updatedForm = forms.map((form: any) => {
        if (form.rxNumber == values.rxNumber) {
          return (form = values);
        } else {
          return form;
        }
      });
      sessionStorage.setItem("rxTabs", JSON.stringify(updatedForm));
      setTabList(updatedForm);
      setTimeout(async () => {
        const bodyData = {
          prescriptionFormList:
            sessionStorage.getItem("rxTabs") !== "undefined" ||
            sessionStorage.getItem("rxTabs") !== null
              ? JSON.parse(sessionStorage.getItem("rxTabs")!)
              : [],
          patientId: patientId,
          userDetails: {
            doctorId:
              UserServiceState?.profileGroup > 6
                ? localStorage.getItem("SupervisorDoctorId")
                : localStorage.getItem("doctorId"),
            onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
            selectedClinicId: sessionStorage.getItem("clinicId"),
          },
        };
        const result: any = await SubmitPresctiptions(bodyData);
        // setPdmpPopup(
        //   result?.data?.response[0]?.popUpFlag?.isPdmpMandatedByState
        // );
        if (result?.data?.digitalRxStatusCode === 200) {
          if (
            result?.data?.response[0]?.prescriptionErrors != null &&
            result?.data?.response[0]?.prescriptionErrors?.length >= 1
          ) {
            sessionStorage.setItem(
              "rxTabsErrors",
              JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
            );

            setStateData((prevState: any) => {
              return {
                ...prevState,
                message: result?.data?.response[0]?.prescriptionErrors?.map(
                  (each: any) => {
                    return (
                      <Box>
                        <Typography
                          component={"div"}
                          fontWeight={600}
                          variant={"body2"}
                        >
                          <strong> Rx-{each?.rxNumber}</strong>
                        </Typography>
                        {each?.errors?.map((ech: any) => {
                          return (
                            <Typography
                              component={"div"}
                              fontWeight={600}
                              variant={"body2"}
                              paddingLeft={2}
                            >
                              {" - "} {ech?.errorMessage}
                            </Typography>
                          );
                        })}
                      </Box>
                    );
                  }
                ),

                variant: "error",
                open: true,
              };
            });
            setSelectedTab(
              `Rx ${result?.data?.response[0]?.prescriptionErrors[0].rxNumber}`
            );

            sessionStorage.setItem(
              "TabValue",
              JSON.stringify(
                result?.data?.response[0]?.prescriptionErrors[0].rxNumber?.toString()
              )
            );
            setSubmitLoad(false);
          } else {
            sessionStorage.removeItem("rxTabsErrors");
            sessionStorage.setItem(
              "locationData",
              JSON.stringify(result?.data?.response[0])
            );
            setSelectedTab("summary");
            navigate("/newrxpad/summary");
            setSubmitLoad(false);
          }
          // sessionStorage.setItem(
          //   "rxTabs",
          //   JSON.stringify(result.data?.response[0]?.prescriptionFormList)
          // );
          setSubmitLoad(false);
        } else {
          setStateData((prevState: any) => {
            return {
              ...prevState,
              message: result?.data?.digitalRxStatusMessage,
              variant: "error",
              open: true,
            };
          });
          setSubmitLoad(false);
        }
      }, 2000);
    } catch (error) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try again after some time!",
          variant: "error",
          open: true,
        };
      });
      setSubmitLoad(false);
    }
  };

  const resetRxForm = async (values: any) => {
    const resTemplate = await getInitializeRxpad(true);
    const currentTabs =
      sessionStorage.getItem("rxTabs") !== "undefined" ||
      sessionStorage.getItem("rxTabs") !== null
        ? JSON.parse(sessionStorage.getItem("rxTabs")!)
        : null;
    const updatedForm = currentTabs?.map((form: any) => {
      if (form.rxNumber === values.rxNumber) {
        resTemplate.rxNumber = form.rxNumber;
        return (form = resTemplate);
      } else {
        return form;
      }
    });
    sessionStorage.setItem("rxTabs", JSON.stringify(updatedForm));
    sessionStorage.removeItem("locationData");
    const currentErrors =
      sessionStorage.getItem("rxTabsErrors") !== "undefined" ||
      sessionStorage.getItem("rxTabsErrors") !== null
        ? JSON.parse(sessionStorage.getItem("rxTabsErrors")!)
        : null;
    if (currentErrors != null) {
      const removeErrorPad = currentErrors?.filter(
        (t: any) => t?.rxNumber !== values.rxNumber
      );
      sessionStorage.setItem("rxTabsErrors", JSON.stringify(removeErrorPad));
    }
    setTabList(updatedForm);

    if (updatedForm?.length === 1 && !updatedForm[0]?.drugId) {
      dispatch(enableClinic());
    } else {
      dispatch(disableClinic());
    }
  };

  const [loading, setLoading] = useState(false);
  const doctorId: any = localStorage.getItem("doctorId");
  const patientId: any = getPatientId();
  const diagnosis: any = getDiagnosis();
  const getInitializeRxpad = async (needRes: Boolean = false) => {
    try {
      setLoading(true);
      const Params = {
        doctorId: doctorId,
        patientId: patientId,
        diagnosis: diagnosis === "null" ? "" : diagnosis,
      };
      const params = new URLSearchParams(Params);
      const result = await InitializeRxPad(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        if (localStorage.getItem("Guide") == "true") {
          localStorage.setItem("GuideON", "true");
          window.dispatchEvent(new Event("storage"));
        } else {
          localStorage.removeItem("Guide");
        }
        if (needRes) {
          setLoading(false);
          return result?.data?.response[0]?.prescriptionForm;
        } else {
          console.log(
            "result?.data?.response[0]?.prescriptionForm",
            result?.data?.response[0]?.prescriptionForm
          );
          sessionStorage.removeItem("freeTextRxTabsErrors");
          sessionStorage.removeItem("freeTextRxTabs");
          setTabList([result?.data?.response[0]?.prescriptionForm]);
          setSelectedTab(
            `Rx ${result?.data?.response[0]?.prescriptionForm?.rxNumber}`
          );
          sessionStorage.setItem("TabValue", JSON.stringify("1"));
          sessionStorage.setItem(
            "rxTabs",
            JSON.stringify([result?.data?.response[0]?.prescriptionForm])
          );
          sessionStorage.setItem(
            "rxTabsErrors",
            JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
          );
          sessionStorage.setItem(
            "rxHubOptions",
            JSON.stringify(
              result?.data?.response[0]?.prescriptionForm
                ?.rxhubPBMUniqueIdOptions
            )
          );
          sessionStorage.setItem(
            "rxhubPBMUniqueId",
            result?.data?.response[0]?.prescriptionForm?.rxhubPBMUniqueId
          );
          dispatch(enableClinic());
        }
        setLoading(false);
      } else {
        setTabList([{ rxNumber: 1 }]);
        setLoading(false);
      }
    } catch (error) {
      setTabList([{ rxNumber: 1 }]);
      setLoading(false);
    }
  };

  const getPostdatedEdit = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams();
      params.append(
        "doctorId",
        UserServiceState?.profileGroup > 6
          ? localStorage.getItem("SupervisorDoctorId")
          : state?.rowData?.doctorId
      );
      params.append("PatientId", state?.rowData?.personId);
      params.append("postDatedPrescriptionId", state?.rowData?.id);
      const result = await PostDatedEdit(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        sessionStorage.setItem(
          "rxTabs",
          JSON.stringify(result?.data?.response)
        );
        sessionStorage.setItem(
          "rxHubOptions",
          JSON.stringify(result?.data?.response[0]?.rxhubPBMUniqueIdOptions)
        );
        sessionStorage.setItem(
          "rxhubPBMUniqueId",
          result?.data?.response[0]?.rxhubPBMUniqueId
        );
        dispatch(disableClinic());
        setTabList(result?.data?.response);
        setSelectedTab("Rx 1");
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (r) {
      setLoading(false);
    }
  };

  const getSavedPrescriptionPopulate = async () => {
    try {
      const tabValue =
        JSON.parse(sessionStorage.getItem("TabValue") ?? "1") - 1;
      setLoading(true);
      const bodyData = {
        prescriptionForm: {
          drugId: state?.rowData?.drugId,
          prescriptionMode: "newrx",
          initQtyQualifierListFlag: "false",
          rxhubPBMUniqueId: sessionStorage.getItem("rxhubPBMUniqueId") ?? "",
          savedPrescriptionId: state?.rowData?.savePersonPrescriptionId,
          rxNumber: JSON.parse(sessionStorage.getItem("TabValue")!) ?? "1",
          rxhubPBMUniqueIdOptions: JSON.parse(
            sessionStorage.getItem("rxHubOptions")!
          ),
        },
        patientId: state?.rowData?.personId,
        userDetails: {
          userId: "",
          doctorId: state?.rowData?.doctorId,
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await EditSavedPrescrition(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        let tabs = JSON.parse(sessionStorage.getItem("rxTabs") ?? "[]");
        tabs[tabValue] = result?.data?.response[0]?.prescriptionForm;
        sessionStorage.setItem("rxTabs", JSON.stringify(tabs));
        setTabList(tabs);
        setSelectedTab(`Rx ${tabValue + 1}`);
        setLoading(false);
        dispatch(disableClinic());
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (er) {
      setLoading(false);
    }
  };

  const getPopulateData = async (props?: any) => {
    try {
      const tabValue =
        JSON.parse(sessionStorage.getItem("TabValue") ?? "1") - 1;
      setLoading(true);
      var bodyData: any = {
        prescriptionForm: {
          practiceFavoriteDrugId:
            state?.key === "PracDrugPop" ? state?.rowData?.personDrugId : "",
          medicationHistoryId:
            state?.key === "MHDrugPop" ? state?.rowData?.personDrugId : "",
          favoriteDrugId:
            state?.key === "favDrugPop" ? state?.rowData?.personDrugId : "",
          drugId:
            state?.key === "LEGACY"
              ? state?.rowData?.drugNDC
              : props?.code ?? state?.rowData?.drugId,
          initQtyQualifierListFlag: "false",
          rxhubPBMUniqueId: sessionStorage.getItem("rxhubPBMUniqueId"),
          rxhubPBMUniqueIdOptions: JSON.parse(
            sessionStorage.getItem("rxHubOptions")!
          ),
          rxNumber: JSON.parse(sessionStorage.getItem("TabValue")!) ?? 1,
        },
        prescriptionFormList:
          JSON.parse(sessionStorage.getItem("rxTabs") ?? "[]")?.length > 1
            ? JSON.parse(sessionStorage.getItem("rxTabs")!)?.filter(
                (t: any) => t?.drugId != null
              )
            : [],
        patientId: patientId,
        userDetails: {
          userId: "",
          doctorId:
            UserServiceState?.profileGroup > 6
              ? localStorage.getItem("SupervisorDoctorId")
              : localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      if (state?.key === "SSMED") {
        bodyData.prescriptionForm.daysSupply = state?.rowData?.daysSupply;
        bodyData.prescriptionForm.rxhistory = "true";
        bodyData.prescriptionForm.quantity = state?.rowData?.quantity;
        bodyData.prescriptionForm.substitutionCode =
          state?.rowData?.substitutionCode;
        bodyData.prescriptionForm.refills = state?.rowData?.refills;
        bodyData.prescriptionForm.dispensibleDrugId =
          state?.rowData?.dispensibleDrugId;
        bodyData.prescriptionForm.pharmacyCode = JSON.parse(
          sessionStorage.getItem("rxTabs") ?? "[]"
        )[tabValue]?.pharmacyCode;
      } else if (state?.key === "LEGACY") {
        bodyData.prescriptionForm.dispensibleDrugId = state?.rowData?.drugId;
        bodyData.prescriptionForm.rxhistory = "true";
        bodyData.prescriptionForm.quantity = state?.rowData?.quantity;
        bodyData.prescriptionForm.refills = state?.rowData?.refills;
        bodyData.prescriptionForm.sig = state?.rowData?.sig;
      }

      const result = await DrugPopulate(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        let tabs = JSON.parse(sessionStorage.getItem("rxTabs") ?? "[]");
        tabs[tabValue] = result?.data?.response[0]?.prescriptionForm;
        sessionStorage.setItem("rxTabs", JSON.stringify(tabs));
        setTabList(tabs);
        setSelectedTab(`Rx ${tabValue + 1}`);
        setLoading(false);
        dispatch(disableClinic());
      } else {
        setLoading(false);
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        setSelectedTab(`Rx ${tabValue + 1}`);
      }
    } catch (er) {
      setLoading(false);
      setSelectedTab(`Rx ${tabValue + 1}`);
    }
  };

  const confirmSavedPrescriptions = async () => {
    try {
      setLoading(true);
      const bodyData = {
        patientId: patientId,
        rxGroupId: sessionStorage.getItem("rxGroupId") ?? "",
        userDetails: {
          doctorId:
            UserServiceState?.profileGroup > 6
              ? localStorage.getItem("SupervisorDoctorId")
              : localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId") ?? "",
        },
        prescriptionIds: null,
      };
      const result: any = await ConfirmSavedPrescriptions(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        sessionStorage.setItem(
          "locationData",
          JSON.stringify(result?.data?.response[0])
        );
        sessionStorage.setItem(
          "rxTabs",
          JSON.stringify(result?.data?.response[0]?.prescriptionFormList)
        );
        sessionStorage.setItem(
          "rxTabsErrors",
          JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
        );
        setTabList(result?.data?.response[0]?.prescriptionFormList);
        setLoading(false);
        dispatch(disableClinic());
        navigate("summary");
        setSelectedTab("summary");
      } else {
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        setLoading(false);
      }
    } catch (er) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try again later!",
          variant: "error",
          open: true,
        };
      });
      setLoading(false);
    }
  };

  const docreeDataSend = () => {
    if (!isDocereeAdsEnabled()) {
      return;
    }
    try {
      const customEvent2 = new CustomEvent("docreeAgeAndGender", {
        detail: patientState,
      });
      document.dispatchEvent(customEvent2);
    } catch (error) {}
  };

  useEffect(() => {
    if (patientState?.age) {
      docreeDataSend();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientState?.age]);

  useEffect(() => {
    if (
      patientState?.pdmpMandatedByState &&
      sessionStorage.getItem("pdmpPopup") !== "false"
    ) {
      setPdmpPopup(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientState?.pdmpMandatedByState]);

  const callSequenceCall = async () => {
    await getInitializeRxpad();
    await getPopulateData();
    await dispatch(loadingPharmacyDropDown());
  };

  const allDrugPops = async () => {
    await getPopulateData();
    await dispatch(loadingPharmacyDropDown());
  };

  const savedPrescriptionDrugPopulate = async () => {
    if (!sessionStorage.getItem("rxTabs")) {
      await getInitializeRxpad();
      await getSavedPrescriptionPopulate();
      await dispatch(loadingPharmacyDropDown());
    } else {
      await getSavedPrescriptionPopulate();
      await dispatch(loadingPharmacyDropDown());
    }
  };

  const postDatedPopulate = async () => {
    await getPostdatedEdit();
    await dispatch(loadingPharmacyDropDown());
  };

  const InitializePopulate = async () => {
    try {
      await getSavedPrescriptionData(0);
      await getAllSavedPrescriptions(0);
      await getInitializeRxpad();
      await dispatch(loadingPharmacyDropDown());
      if (state === "rxGroup") {
        await confirmSavedPrescriptions();
      }
    } catch (error) {
      console.log("🚀 ~ InitializePopulate ~ error:", error);
    }
  };
  useEffect(() => {
    if (
      (state === "comingFromPatientSearch" ||
        state === "integratedLogin" ||
        state === "fromRegistration" ||
        !sessionStorage.getItem("rxTabs")) &&
      tabValue === 1 &&
      state?.key !== "MHDrugPop" &&
      state?.key !== "favDrugPop" &&
      state?.key !== "postDated" &&
      state?.key !== "comingSavedPres" &&
      state?.key !== "PracDrugPop" &&
      state?.key !== "SSMED"
    ) {
      InitializePopulate();
      // Promise.all([getInitializeRxpad(), dispatch(loadingPharmacyDropDown())]);
      // getSavedPrescriptionData(0);
      // getAllSavedPrescriptions(0);
    } else if (state?.key === "postDated") {
      postDatedPopulate();
      // Promise.all([dispatch(loadingPharmacyDropDown()), getPostdatedEdit()]);
    } else if (state?.key === "comingSavedPres") {
      savedPrescriptionDrugPopulate();
      // Promise.all([
      //   getSavedPrescriptionPopulate(),
      //   dispatch(loadingPharmacyDropDown()),
      // ]);
    } else if (
      state?.key === "favDrugPop" ||
      state?.key === "MHDrugPop" ||
      state?.key === "PracDrugPop" ||
      state?.key === "SSMED" ||
      state?.key === "LEGACY"
    ) {
      if (!sessionStorage.getItem("rxTabs")) {
        callSequenceCall();
      } else {
        allDrugPops();
        // Promise.all([getPopulateData(), dispatch(loadingPharmacyDropDown())]);
      }
    } else {
      sessionStorage.setItem("TabValue", JSON.stringify("1"));
      // dispatch(loadingPharmacyDropDown());
    }

    window.dispatchEvent(new Event("storage"));
  }, []);

  useEffect(() => {
    if (rxTabsData) {
      setTabList(
        sessionStorage.getItem("rxTabs") !== "undefined" ||
          sessionStorage.getItem("rxTabs") !== null
          ? JSON.parse(sessionStorage.getItem("rxTabs")!)
          : []
      );
    }
    if (
      JSON.parse(sessionStorage.getItem("rxTabs")!)?.length === 1 &&
      !JSON.parse(sessionStorage.getItem("rxTabs")!)[0]?.drugId
    ) {
      dispatch(enableClinic());
    } else {
      dispatch(disableClinic());
    }
    if (!sessionStorage.getItem("TabValue")) {
      sessionStorage.setItem("TabValue", JSON.stringify("1"));
    }
  }, []);

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const authCheck: any = searchParams.get("authorization");
    const printCheck: any = searchParams.get("printFlag");
    if (
      state === "confirmMhList" ||
      state === "confirmSpList" ||
      state === "confirmFdList" ||
      state === "confirmAspList" ||
      state === "confirmPfdList" ||
      state === "confirmPrescTemplate" ||
      (printCheck == "true" && authCheck == "true") ||
      (authCheck == "true" && printCheck == null)
    ) {
      //setTabList(NavigatedTabs?.prescriptionFormList);
      //setTabValue(NavigatedTabs?.prescriptionFormList?.length);
      setSelectedTab("summary");
      dispatch(loadingPharmacyDropDown());
      dispatch(disableClinic());
      // sessionStorage.setItem(
      //   "rxTabs",
      //   JSON.stringify(NavigatedTabs?.prescriptionFormList)
      // );
    }
  }, [state]);

  const getSavedPrescriptionData = (nextPage: number) => {
    let paramdata = {
      pageNumber: nextPage,
      patientId: sessionStorage.getItem("patientId"),
      doctorId:
        UserServiceState?.profileGroup > 6
          ? localStorage.getItem("SupervisorDoctorId")
          : localStorage.getItem("doctorId"),
    };
    dispatch(loadingSavedPrescriptions(paramdata));
  };

  const getAllSavedPrescriptions = (nextPage: number) => {
    let pageNumber = {
      pageNumber: nextPage,
      pageSize: 10,
      doctorId:
        UserServiceState?.profileGroup > 6
          ? localStorage.getItem("SupervisorDoctorId")
          : localStorage.getItem("doctorId"),
    };
    dispatch(loadingAllSavedPrescriptions(pageNumber));
  };

  useEffect(() => {
    if (!summaryTab && selectedTab === "summary") {
      setSummaryTab(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTab]);
  return (
    <>
      {loading ? (
        <Box
          style={{
            width: "100%",
            height: 200,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body1"
            color={"primary"}
            component="div"
            fontWeight={500}
          >
            Please wait while we fetch the patient's history!
          </Typography>
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <>
          <TabsNav />
          <ContentStyle>
            <TabContext value={selectedTab}>
              <Grid
                container
                xs={12}
                spacing={0}
                alignItems="center"
                justifyContent="flex-start"
              >
                <Grid item xs={12}>
                  <RxTabsStyle>
                    <Box style={{ display: "flex" }}>
                      <TabList
                        variant="scrollable"
                        scrollButtons="auto"
                        onChange={handleChange}
                        className={"tablist"}
                      >
                        {memoData?.map((tab: any) => (
                          <Tab
                            key={tab?.rxNumber}
                            label={
                              <Tooltip
                                title={tab?.drugName}
                                placement="top"
                                arrow
                              >
                                <span>Rx {tab?.rxNumber}</span>
                              </Tooltip>
                            }
                            value={`Rx ${tab?.rxNumber}`}
                            iconPosition="end"
                            icon={
                              tab?.rxNumber !== 1 ? (
                                <IconButton
                                  color="error"
                                  className="remove"
                                  id={tab?.rxNumber}
                                  aria-label="close"
                                  onClick={() => {
                                    handleShowDeletePopupClick();
                                    setdeleteRxdata(tab?.rxNumber);
                                  }}
                                >
                                  <img
                                    src={DeleteIcon}
                                    alt="DeleteIcon"
                                    loading="lazy"
                                  />
                                </IconButton>
                              ) : (
                                ""
                              )
                            }
                          />
                        ))}
                      </TabList>
                      <YSButton
                        color="inherit"
                        children="Summary"
                        variant="outlined"
                        type="button"
                        disabled={
                          // JSON.parse(sessionStorage.getItem("locationData")!)
                          //   ?.prescriptionFormList?.length ===
                          // JSON.parse(sessionStorage.getItem("rxTabs") ?? "[]")
                          //   ?.length
                          //   ? false
                          //   : true
                          !summaryTab
                        }
                        onClick={() => {
                          navigate("/newrxpad/summary");
                          setSelectedTab("summary");
                        }}
                        size="large"
                        className={
                          selectedTab === "summary"
                            ? "summary-btn active"
                            : "summary-btn"
                        }
                      />
                    </Box>
                  </RxTabsStyle>
                </Grid>
              </Grid>
              {memoData?.map((panel: any, index: any) => (
                <TabPanel
                  key={panel?.rxNumber}
                  value={`Rx ${panel?.rxNumber}`}
                  style={{ padding: 0, width: "100%" }}
                >
                  <RxForm
                    newPrescription={newPrescription}
                    getPopulateData={getPopulateData}
                    saveAndContinue={saveAndContinue}
                    tabListLength={memoData?.length}
                    submitAllForms={submitAllForms}
                    submitLoad={submitLoad}
                    resetRxForm={resetRxForm}
                    panel={panel}
                    setTabList={setTabList}
                  />
                </TabPanel>
              ))}

              <TabPanel value={"summary"} style={{ padding: 0, width: "100%" }}>
                <PrescriptionSummary
                  setSelectedTab={setSelectedTab}
                  getInitializeRxpad={getInitializeRxpad}
                  setTabList={setTabList}
                  setSummaryTab={setSummaryTab}
                  // setTabValue={setTabValue}
                />
              </TabPanel>
            </TabContext>
          </ContentStyle>
        </>
      )}
      <DialogPopup
        windowsize={"sm"}
        show={deleteDataPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <Grid container spacing={0}>
          <Grid item xs={12} textAlign="center" marginTop={6}>
            <Typography component={"div"} variant={"h6"} fontWeight={350}>
              {`Are you sure? Want to delete the ${deteteRxData}`}
            </Typography>
            <Grid
              item
              xs={12}
              textAlign="center"
              marginTop={5}
              className="btns"
            >
              <BtnGroupWAStyle>
                <YSButton
                  color="secondary"
                  children="Cancel"
                  variant="outlined"
                  type="button"
                  onClick={handleHideDeletePopupClick}
                  size="large"
                  className=""
                />{" "}
                <YSButton
                  children="Confirm"
                  variant="contained"
                  type="button"
                  onClick={(event) => {
                    handleHideDeletePopupClick();
                    handleClose(event, deteteRxData);
                    setSummaryTab(false);
                  }}
                  size="large"
                  className=""
                />
              </BtnGroupWAStyle>
            </Grid>
          </Grid>
        </Grid>
      </DialogPopup>
      <Dialog open={pdmpPopup} onClose={handleClose}>
        <DialogTitle>PMP/ PDMP Report Review Required</DialogTitle>
        <DialogContent>
          <Typography component={"span"} fontWeight={500}>
            State regulations require you to review the patient’s Prescription
            Monitoring Program (PMP) report before prescribing controlled
            substances. Please check the PMP report to proceed with the
            prescription in compliance with PDMP mandates.
          </Typography>
        </DialogContent>
        <DialogActions>
          <BtnGroupWAStyle>
            <YSButton
              color="primary"
              children={
                UserServiceState?.pdmpServiceLevels?.enabled
                  ? "Ok"
                  : "I've reviewed it elsewhere"
              }
              variant="contained"
              size="small"
              onClick={handleHidePdmpPopupClick}
            />
          </BtnGroupWAStyle>
        </DialogActions>
      </Dialog>
      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
